import axios from 'axios';
import { useEffect, useState } from 'react';
import { StripeComponent } from './Stripe/stripe';
import { useSearchParams } from 'react-router-dom';
import './subscription.css'
import img from '../../resources/chicken-caesar-salad-black-background 1.png'
import { FaCircle } from "react-icons/fa";
import amex from '../../resources/amex-icon.png'
import visa from '../../resources/visa-icon.webp'
import mastercard from '../../resources/mastercard-icon.jpg'
import discover from '../../resources/discover-icon.png'
import Radio from '@mui/material/Radio';
import FullScreenOverlay from "../../Components/FullScreenOverlay/FullScreenOverlay.js";
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import SavePaymentMethodForm from '../Billing/PaymentMethod/save_payment_method_form';
import logo from '../../resources/Frame 1.svg'
import { useNavigate } from 'react-router-dom';
import { get, post } from '../../Services/api.js';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

function Subscription({ user_data }) {
    const current_env = process.env.NODE_ENV
    const [paymentMethods, setPaymentMethods] = useState();
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState();
    const [choosePaymentMethod, setChoosePaymentMethod] = useState(false)
    const [modalOpen, setModalOpen] = useState(false)
    const [getDataDone, setGetDataDone] = useState(false)
    const [selectedPlan, setSelectedPlan] = useState();
    const [searchParams] = useSearchParams();
    const [price, setPrice] = useState()
    const [product, setProduct] = useState()
    const plan_id = searchParams.get('plan_id');
    const [clientSecret, setClientSecret] = useState('');
    const [default_payment_method, setDefault_payment_method] = useState(false)
    const [billingData, setBillingData] = useState()
    const [pastFreeTrials, setPastFreeTrials] = useState()
    const [trialEnd, setTrialEnd] = useState()
    const [appleSubscription, setAppleSubscription] = useState(false)
    const navigate = useNavigate();


    function goToPage(path) {
        navigate(path);
    }

    useEffect(() => {
        // Get payment plans
        getPaymentPlans()
    }, []);

    useEffect(() => {
        // Get plan Price & Product
        retrievePaymentPlan()
    }, [selectedPlan]);

    useEffect(() => {
        // Get user payment methods
        if (selectedPlan)
            getPaymentMethods()
    }, [user_data, selectedPlan]);


    async function retrievePaymentPlan() {
        if (selectedPlan) {
            const res = await get("/api/billing/stripe/get-price-product?price_id=" + selectedPlan.price_id)

            setPrice(res.price)
            setProduct(res.product)
        }
    }

    async function getPaymentPlans() {
        try {
            const res = await get("/api/billing/get-all-payment-plans")

            planSelected(res, plan_id)
        } catch (error) {
            console.log("Error fetching payment plans:", error);
            return;
        }
    }

    function planSelected(all_plans, plan_id) {
        all_plans.map(plan => {
            if (plan.payment_plan_id == plan_id) {
                setSelectedPlan(plan)
            }
        })
    }

    async function getPaymentMethods() {
        try {
            const res = await get("/api/billing/stripe/get-billing-detail?user_id=" + user_data.uid)
            const billingData = res
            setBillingData(billingData)

            // get past free trials
            const res_free_trials = await get('/api/billing/stripe/user-past-free-trials?user_id=' + user_data.uid)
            const past_free_trials = res_free_trials
            setPastFreeTrials(past_free_trials)

            // Check for active subscripotion
            const past_subscription = await getCurrentSubscription(billingData)
            const trial_end = past_subscription.current_period_end ? past_subscription.current_period_end : null
            if (trial_end) {
                const trial_end_date = new Date(trial_end * 1000)
                // Add trial period to date if no previous trial and subsciprtion has a free trial
                if (!pastFreeTrials && selectedPlan.trial_days && selectedPlan.trial_days != 0)
                    trial_end_date.setDate(trial_end_date.getDate() + selectedPlan.trial_days);
                const formattedDate = trial_end_date.toLocaleDateString('en-US', {
                    month: 'short', // "Jan", "Feb", etc.
                    day: 'numeric'  // "1", "2", etc.
                });
                setTrialEnd(formattedDate)
            }

            // get customer to see default payment method
            const res_customer = await get("/api/billing/stripe/get-customer?id=" + billingData.customer_id)

            // get all attached payment methods
            const res_payment_methods = await get("/api/billing/stripe/get-customer-payment-methods?id=" + billingData.customer_id)
            const payment_methods = []
            if (res_payment_methods.data)
                res_payment_methods.data.map((method) => {
                    if (method.id === res_customer.invoice_settings.default_payment_method) {
                        payment_methods.push({ ...method, default_payment_method: true })
                        setSelectedPaymentMethod({ ...method, default_payment_method: true })
                    }
                    else payment_methods.push(method)
                })
            setPaymentMethods(payment_methods)
        } catch (error) {
            console.log(error)
        }

        // Show data
        setGetDataDone(true)
    }

    // get subscription detail
    async function getCurrentSubscription(billingData) {
        try {
            if (billingData.payment_provider_fk == 1)
                setAppleSubscription(true)

            const res = await get("/api/billing/stripe/get-subscription?id=" + billingData.subscription_id)

            // redirect to dashboard if avtive subscription
            if (res.status == 'active' || res.status == 'trialing')
                window.location = '/'
            else
                return res
        } catch (error) {
            console.log(error)
        }
    }

    async function setupIntent() {
        const res = await post("/api/billing/stripe/setup-intent")
        setClientSecret(res.client_secret)
    }
    const options = { clientSecret: clientSecret };

    return (
        <div className='checkout_page flex align_center justify_center'>
            {(selectedPlan && price && product) ?
                <div className='flex gap_40 justify_center flex_wrap'>
                    <div className='checkout_form_div'>
                        <div className='checkout_form_log_div flex gap_20'>
                            <img width={40} src={logo} />
                            <h2 className='word_break font_weight_600 gray_scale_1'>Meal Planner AI</h2>
                        </div>

                        {appleSubscription ? <div>
                            <div className="width_fit_content">
                                <a href={'https://www.apple.com/in/app-store/'} target="_blank" className="text_decoration_none ">
                                    <p className="billing_overview_reactivate_button cursor_pointer text_decoration_none font_size_16 width_fit_content">Visit App Store</p>
                                </a>
                            </div>
                            <br />
                            <p className="italic ">You can manage your subscription through the App Store</p>
                        </div>

                            : <div>
                                <div className='checkout_form_price_detail flex flex_column gap_8'>
                                    <h2 className='font_weight_600 gray_scale_2'>${trialEnd || (!pastFreeTrials && selectedPlan.trial_days && selectedPlan.trial_days != 0) ? '0.00' : price.unit_amount / 100}</h2>
                                    {trialEnd || (!pastFreeTrials && selectedPlan.trial_days && selectedPlan.trial_days != 0) ? <p className='gray_scale_2'>Payment starts from {trialEnd ? trialEnd
                                        : (new Date(new Date().setDate(new Date().getDate() + selectedPlan.trial_days))
                                            .toLocaleDateString('en-US', { month: 'short', day: 'numeric' }))} at ${price.unit_amount / 100}</p> : null}
                                    <p className='gray_scale_2'>{product.name} will be charged monthly</p>
                                </div>
                                {getDataDone ?
                                    <div>
                                        {(selectedPaymentMethod && !choosePaymentMethod) ?
                                            <div className='checkout_selected_payment_method flex gap_20 cursor_pointer' onClick={() => setChoosePaymentMethod(true)}>
                                                <p className='green_1'>Pay with</p>
                                                <div className='flex flex_column gap_8'>
                                                    <div className='flex gap_12'>
                                                        <p className='font_size_16'>{selectedPaymentMethod.card.brand}</p>

                                                        <div className="flex align_center">
                                                            <div className="billing_payment_method_number_bullets">
                                                                <FaCircle size={6} color="#1F2933" />
                                                            </div>
                                                            <div className="billing_payment_method_number_bullets">
                                                                <FaCircle size={6} color="#1F2933" />
                                                            </div>
                                                            <div className="billing_payment_method_number_bullets">
                                                                <FaCircle size={6} color="#1F2933" />
                                                            </div>
                                                            <div className="billing_payment_method_number_bullets">
                                                                <FaCircle size={6} color="#1F2933" />
                                                            </div>
                                                            <p className="font_size_16">{selectedPaymentMethod.card.last4}</p>
                                                        </div>
                                                    </div>
                                                    <p className="font_size_12">Expires {selectedPaymentMethod.card.exp_month.toString().padStart(2, '0')}/{selectedPaymentMethod.card.exp_year}</p>
                                                </div>
                                            </div>
                                            : null
                                        }

                                        {choosePaymentMethod ?
                                            <div className='checkout_selected_payment_method flex flex_column gap_20'>
                                                <p onClick={() => setChoosePaymentMethod(false)} className='green_1 cursor_pointer'>{'< back'}</p>
                                                {paymentMethods.map((card, i) => (
                                                    <div key={i} className='flex gap_20 cursor_pointer' onClick={() => setSelectedPaymentMethod(card)}>
                                                        <Radio checked={card.id == selectedPaymentMethod.id} />

                                                        <img src={
                                                            card.card.display_brand == 'visa' ? visa :
                                                                (card.card.display_brand == 'american_express' ? amex
                                                                    : (card.card.display_brand == 'mastercard' ? mastercard
                                                                        : card.card.display_brand == 'discover' ? discover
                                                                            : null))
                                                        } width={50} height={32} className="billing_payment_method_card_image" />

                                                        <div className='flex flex_column gap_8'>
                                                            <div className='flex gap_12'>
                                                                <div className="flex align_center">
                                                                    <div className="billing_payment_method_number_bullets">
                                                                        <FaCircle size={6} color="#1F2933" />
                                                                    </div>
                                                                    <div className="billing_payment_method_number_bullets">
                                                                        <FaCircle size={6} color="#1F2933" />
                                                                    </div>
                                                                    <div className="billing_payment_method_number_bullets">
                                                                        <FaCircle size={6} color="#1F2933" />
                                                                    </div>
                                                                    <div className="billing_payment_method_number_bullets">
                                                                        <FaCircle size={6} color="#1F2933" />
                                                                    </div>
                                                                    <p className="font_size_16">{card.card.last4}</p>
                                                                </div>
                                                            </div>
                                                            <p className="font_size_12">Expires {card.card.exp_month.toString().padStart(2, '0')}/{card.card.exp_year}</p>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                            : null
                                        }

                                        {(!modalOpen && selectedPaymentMethod) ?
                                            <button className="billing_payment_method_default_button cursor_pointer" onClick={() => { setModalOpen(true); setupIntent(); }}>Add Payment Method</button>
                                            : null}

                                        <StripeComponent selectedPlan={selectedPlan} user_data={user_data} selectedPaymentMethod={selectedPaymentMethod} trial_days={!pastFreeTrials ? selectedPlan.trial_days : null} />


                                        {(modalOpen && clientSecret) ?
                                            <FullScreenOverlay modalOpen={modalOpen} setModalOpen={setModalOpen}>
                                                <div className="billing_payment_method_add_div">
                                                    <div>
                                                        <Elements stripe={stripePromise} options={options}>
                                                            <SavePaymentMethodForm user_data={user_data}
                                                                default_payment_method={!paymentMethods.length ? true : default_payment_method}
                                                                customer_id={billingData.customer_id}
                                                                setDefault_payment_method={setDefault_payment_method}
                                                                only_payment_method={!paymentMethods.length}
                                                            />
                                                        </Elements>
                                                    </div>
                                                </div>
                                            </FullScreenOverlay>
                                            : null}
                                    </div>
                                    : null}
                            </div>}

                    </div>
                    <div className='checkout_form_div'>
                        <img src={img} className='checkout_image' />
                    </div>
                </div>
                : null
            }
        </div >
    );
}


export default Subscription;